// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  width: 100%;
  height: auto;
}

.navbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 20;
  background-color: var(--color-blue-cream);
  box-shadow: 0px 2px 10px #888888;
}

.navbar .navbar-main {
  width: 80%;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.navbar .navbar-main .logo-header {
  width: 20%;
  height: 100px;
  display: flex;
  align-items: center;
}

.navbar .navbar-main .logo-header img {
  width: 100px;
  height: 6vh;
  display: block;
  z-index: 20;
}

.navbar .navbar-main .navbar-items {
  width: 80%;
  height: 100px;
}

.navbar .navbar-main .navbar-items .navbar-item {
  width: 100%;
  height: inherit;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.navbar .navbar-main .navbar-items .navbar-item .search-box {
  width: 65%;
  display: flex;
  justify-content: space-between;
  position: relative;
  text-align: center;
}

.navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {
  width: 90%;
  height: 50px;
  border-radius: 50px;
  background-color: var(--color-white-main);
  display: center;
  align-items: center;
  align-content: center;
  padding: 10px 30px;
  border: 2px solid var(--color-border-gray);
  margin-right: 5px;
  font-size: 16px;
  font-weight: 300;
  color: var(--color-text-gray);
  font-family: "Poppins", sans-serif;
}

.navbar .navbar-main .navbar-items .navbar-item .search-box .search-input:hover,
.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .search-box
  .search-input:focus {
  background-color: var(--color-white-cream);
  outline: none;
}

.navbar .navbar-main .navbar-items .navbar-item .search-box .search-button {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-color: var(--color-blue-dark);
  border: none;
  font-size: 20px;
  color: var(--color-white-main);
}

.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .search-box
  .search-button:hover {
  background-color: var(--color-blue-circle);
  cursor: pointer;
}

.navbar .navbar-main .navbar-items .navbar-item .cart-info {
  width: 35%;
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.navbar .navbar-main .navbar-items .navbar-item .cart-info .cart-input {
  width: auto;
  height: auto;
}

.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .cart-info
  .cart-input
  .cart-button {
  border-radius: 50px;
  background-color: var(--color-blue-dark);
  width: 34px;
  height: 34px;
  border-radius: 100%;
  border: none;
  font-size: 15px;
  color: var(--color-white-main);
  display: block;
  text-align: center;
  line-height: 38px;
  position: relative;
}

.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .cart-info
  .cart-input
  .cart-button
  .count-cart {
  position: absolute;
  font-size: 11px;
  color: var(--color-white-main);
  top: -14px;
  right: -6px;
  background-color: #000000;
  line-height: 28px;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  font-weight: bolder;
  font-family: "Poppins", sans-serif;
}

.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .cart-info
  .cart-input
  .cart-button:hover {
  background-color: var(--color-blue-circle);
  cursor: pointer;
}

.navbar .navbar-main .navbar-items .navbar-item .cart-info .cart-text {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
}

.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .cart-info
  .cart-text
  .cart-title {
  font-family: "Lexend Deca", sans-serif;
  font-size: 12px;
  font-weight: 300;
  color: var(--color-text-gray);
}

.navbar
  .navbar-main
  .navbar-items
  .navbar-item
  .cart-info
  .cart-text
  .cart-price {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text-dark);
}

.navbar .navbar-main .navbar-items .navbar-item .navbar-title {
  width: 75%;
  text-align: center;
}

.navbar .navbar-main .navbar-items .navbar-item .navbar-logo {
  width: 25%;
  height: inherit;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {
  display: block;
  width: 130px;
}

.navbar .navbar-main .navbar-items .navbar-item p {
  color: var(--color-text-gray);
  font-family: "Lexend Deca", sans-serif;
  font-size: 24px;
}

.navbar .navbar-main .navbar-items .navbar-item p span {
  color: var(--color-text-blue);
}

.header-mb {
  display: none;
}

@media only screen and (max-width: 600px) {
  .navbar .navbar-main {
    width: 90%;
    height: 8vh;
    position: relative;
    padding: 0;
  }

  .navbar .logo-header {
    width: 25%;
    height: 80px;
    z-index: 20;
  }

  .navbar .navbar-items {
    width: 75%;
  }

  .navbar .navbar-items .navbar-item .search-box,
  .navbar .navbar-items .navbar-item .navbar-title {
    display: none !important;
  }

  .navbar .navbar-items .navbar-item {
    width: 100%;
    height: 100px;
    flex-direction: column-reverse;
    align-items: center !important;
    flex-wrap: wrap;
    position: absolute;
    left: 0;
  }

  .navbar .navbar-items .navbar-item .cart-info {
    width: 100% !important;
    position: absolute;
    top: 0px !important;
  }

  .navbar .navbar-items .navbar-item .search-box {
    position: static;
    top: 0;
    width: 100% !important;
    height: 10%;
    top: 0px;
  }

  .navbar .navbar-items .navbar-item .navbar-title {
    position: absolute;
    width: 100% !important;
    top: 140px;
  }

  .navbar .navbar-items .navbar-item .navbar-title p {
    font-size: 18px;
  }

  .navbar .navbar-items .navbar-item .navbar-logo {
    width: 100% !important;
  }

  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {
    width: 130px;
  }

  .header-mb {
    display: block;
    width: 100%;
    height: auto;
    margin-top: 16vh;
  }

  .header-mb .navbar-item {
    width: 90%;
    height: auto;
    margin: auto;
  }

  .header-mb .navbar-item .search-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    text-align: center;
  }

  .header-mb .navbar-item .search-box .search-input {
    width: 80%;
    height: 50px;
    border-radius: 50px;
    background-color: var(--color-white-main);
    display: center;
    align-items: center;
    align-content: center;
    padding: 10px 30px;
    border: 2px solid var(--color-border-gray);
    margin-right: 5px;
    font-size: 16px;
    font-weight: 300;
    color: var(--color-text-gray);
    font-family: "Poppins", sans-serif;
  }

  .header-mb .navbar-item .search-box .search-input:hover,
  .header-mb .navbar-item .search-box .search-input:focus {
    background-color: var(--color-white-cream);
    outline: none;
  }

  .header-mb .navbar-item .search-box .search-button {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: var(--color-blue-dark);
    border: none;
    font-size: 20px;
    color: var(--color-white-main);
  }

  .header-mb .navbar-item .search-box .search-button:hover {
    background-color: var(---color-blue-circle);
    cursor: pointer;
  }

  .header-mb .navbar-item .navbar-title {
    width: 100%;
    text-align: center;
  }

  .header-mb .navbar-item .navbar-title p {
    color: var(--color-text-gray);
    font-family: "Lexend Deca", sans-serif;
    font-size: 17.3px;
  }

  .header-mb .navbar-item .navbar-title p span {
    color: var(--color-text-blue);
  }
  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {
    width: 130px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  header {
    width: 100%;
    height: auto;
  }
  
  .navbar .navbar-main {
    width: 90%;
    height: 100px;
  }

  .navbar .navbar-main .logo-header {
    width: 20%;
    height: 100px;
    display: flex;
    align-items: center;
  }

  .navbar .navbar-main .logo-header img {
    width: 100px;
    height: auto;
    display: block;
  }

  .navbar .navbar-main .navbar-items {
    width: 80%;
    height: 100px;
  }

  .navbar .navbar-main .navbar-items .navbar-item {
    width: 100%;
    height: inherit;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .navbar .navbar-main .navbar-items .navbar-item .search-box {
    width: 60%;
    display: flex;
    justify-content: space-between;
    position: relative;
    text-align: center;
  }

  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {
    width: 75%;
    height: 50px;
  }

  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-button {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: none;
    font-size: 20px;
  }

  .navbar .navbar-main .navbar-items .navbar-item .cart-info {
    width: 40%;
    height: inherit;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .navbar .navbar-main .navbar-items .navbar-item .cart-info .cart-input {
    width: auto;
    height: auto;
  }

  .navbar
    .navbar-main
    .navbar-items
    .navbar-item
    .cart-info
    .cart-input
    .cart-button {
    border-radius: 50px;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: none;
    font-size: 20px;
    display: block;
    text-align: center;
    line-height: 50px;
    position: relative;
  }

  .navbar
    .navbar-main
    .navbar-items
    .navbar-item
    .cart-info
    .cart-input
    .cart-button
    .count-cart {
    position: absolute;
    font-size: 11px;
    top: -12px;
    right: -3px;
    line-height: 24px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    font-weight: bolder;
    font-family: "Poppins", sans-serif;
  }

  .navbar
    .navbar-main
    .navbar-items
    .navbar-item
    .cart-info
    .cart-text
    .cart-title {
    font-family: "Lexend Deca", sans-serif;
    font-size: 16px;
    font-weight: 300;
  }

  .navbar
    .navbar-main
    .navbar-items
    .navbar-item
    .cart-info
    .cart-text
    .cart-price {
    font-family: "Poppins", sans-serif;
    font-size: 18px;
    font-weight: 600;
  }

  .navbar .navbar-main .navbar-items .navbar-item .navbar-title {
    width: 70%;
    text-align: center;
  }

  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo {
    width: 30%;
    height: inherit;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {
    width: 130px;
  }

  .navbar .navbar-main .navbar-items .navbar-item p {
    color: var(--color-text-gray);
    font-family: "Lexend Deca", sans-serif;
    font-size: 18px;
  }

  .navbar .navbar-main .navbar-items .navbar-item p span {
    color: var(--color-text-blue);
  }

  .header-mb {
    display: none;
  }
}

@media only screen and (min-width: 1025px) {
  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {
    width: 86%;
    height: 50px;
  }
}

@media only screen and (min-width: 1600px) { 
  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {
    width: 87.5%;
    height: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/header/Header.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;;;;;;EAOE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA;;;;;;EAME,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;;;;;EAOE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;;IAEE,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;IACZ,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,2CAA2C;IAC3C,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;IAOE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;;;;;;IAQE,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;;;;;;;IAOE,sCAAsC;IACtC,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;;;;IAOE,kCAAkC;IAClC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["@import url(\"../../../App.css\");\n\nheader {\n  width: 100%;\n  height: auto;\n}\n\n.navbar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n  z-index: 20;\n  background-color: var(--color-blue-cream);\n  box-shadow: 0px 2px 10px #888888;\n}\n\n.navbar .navbar-main {\n  width: 80%;\n  height: 100px;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.navbar .navbar-main .logo-header {\n  width: 20%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n}\n\n.navbar .navbar-main .logo-header img {\n  width: 100px;\n  height: 6vh;\n  display: block;\n  z-index: 20;\n}\n\n.navbar .navbar-main .navbar-items {\n  width: 80%;\n  height: 100px;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item {\n  width: 100%;\n  height: inherit;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .search-box {\n  width: 65%;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  text-align: center;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {\n  width: 90%;\n  height: 50px;\n  border-radius: 50px;\n  background-color: var(--color-white-main);\n  display: center;\n  align-items: center;\n  align-content: center;\n  padding: 10px 30px;\n  border: 2px solid var(--color-border-gray);\n  margin-right: 5px;\n  font-size: 16px;\n  font-weight: 300;\n  color: var(--color-text-gray);\n  font-family: \"Poppins\", sans-serif;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .search-box .search-input:hover,\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .search-box\n  .search-input:focus {\n  background-color: var(--color-white-cream);\n  outline: none;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .search-box .search-button {\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  background-color: var(--color-blue-dark);\n  border: none;\n  font-size: 20px;\n  color: var(--color-white-main);\n}\n\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .search-box\n  .search-button:hover {\n  background-color: var(--color-blue-circle);\n  cursor: pointer;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .cart-info {\n  width: 35%;\n  height: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .cart-info .cart-input {\n  width: auto;\n  height: auto;\n}\n\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .cart-info\n  .cart-input\n  .cart-button {\n  border-radius: 50px;\n  background-color: var(--color-blue-dark);\n  width: 34px;\n  height: 34px;\n  border-radius: 100%;\n  border: none;\n  font-size: 15px;\n  color: var(--color-white-main);\n  display: block;\n  text-align: center;\n  line-height: 38px;\n  position: relative;\n}\n\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .cart-info\n  .cart-input\n  .cart-button\n  .count-cart {\n  position: absolute;\n  font-size: 11px;\n  color: var(--color-white-main);\n  top: -14px;\n  right: -6px;\n  background-color: #000000;\n  line-height: 28px;\n  width: 26px;\n  height: 26px;\n  border-radius: 100%;\n  font-weight: bolder;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .cart-info\n  .cart-input\n  .cart-button:hover {\n  background-color: var(--color-blue-circle);\n  cursor: pointer;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .cart-info .cart-text {\n  display: flex;\n  flex-direction: column;\n  margin-left: 15px;\n}\n\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .cart-info\n  .cart-text\n  .cart-title {\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 12px;\n  font-weight: 300;\n  color: var(--color-text-gray);\n}\n\n.navbar\n  .navbar-main\n  .navbar-items\n  .navbar-item\n  .cart-info\n  .cart-text\n  .cart-price {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--color-text-dark);\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .navbar-title {\n  width: 75%;\n  text-align: center;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .navbar-logo {\n  width: 25%;\n  height: inherit;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {\n  display: block;\n  width: 130px;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item p {\n  color: var(--color-text-gray);\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 24px;\n}\n\n.navbar .navbar-main .navbar-items .navbar-item p span {\n  color: var(--color-text-blue);\n}\n\n.header-mb {\n  display: none;\n}\n\n@media only screen and (max-width: 600px) {\n  .navbar .navbar-main {\n    width: 90%;\n    height: 8vh;\n    position: relative;\n    padding: 0;\n  }\n\n  .navbar .logo-header {\n    width: 25%;\n    height: 80px;\n    z-index: 20;\n  }\n\n  .navbar .navbar-items {\n    width: 75%;\n  }\n\n  .navbar .navbar-items .navbar-item .search-box,\n  .navbar .navbar-items .navbar-item .navbar-title {\n    display: none !important;\n  }\n\n  .navbar .navbar-items .navbar-item {\n    width: 100%;\n    height: 100px;\n    flex-direction: column-reverse;\n    align-items: center !important;\n    flex-wrap: wrap;\n    position: absolute;\n    left: 0;\n  }\n\n  .navbar .navbar-items .navbar-item .cart-info {\n    width: 100% !important;\n    position: absolute;\n    top: 0px !important;\n  }\n\n  .navbar .navbar-items .navbar-item .search-box {\n    position: static;\n    top: 0;\n    width: 100% !important;\n    height: 10%;\n    top: 0px;\n  }\n\n  .navbar .navbar-items .navbar-item .navbar-title {\n    position: absolute;\n    width: 100% !important;\n    top: 140px;\n  }\n\n  .navbar .navbar-items .navbar-item .navbar-title p {\n    font-size: 18px;\n  }\n\n  .navbar .navbar-items .navbar-item .navbar-logo {\n    width: 100% !important;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {\n    width: 130px;\n  }\n\n  .header-mb {\n    display: block;\n    width: 100%;\n    height: auto;\n    margin-top: 16vh;\n  }\n\n  .header-mb .navbar-item {\n    width: 90%;\n    height: auto;\n    margin: auto;\n  }\n\n  .header-mb .navbar-item .search-box {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    text-align: center;\n  }\n\n  .header-mb .navbar-item .search-box .search-input {\n    width: 80%;\n    height: 50px;\n    border-radius: 50px;\n    background-color: var(--color-white-main);\n    display: center;\n    align-items: center;\n    align-content: center;\n    padding: 10px 30px;\n    border: 2px solid var(--color-border-gray);\n    margin-right: 5px;\n    font-size: 16px;\n    font-weight: 300;\n    color: var(--color-text-gray);\n    font-family: \"Poppins\", sans-serif;\n  }\n\n  .header-mb .navbar-item .search-box .search-input:hover,\n  .header-mb .navbar-item .search-box .search-input:focus {\n    background-color: var(--color-white-cream);\n    outline: none;\n  }\n\n  .header-mb .navbar-item .search-box .search-button {\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    background-color: var(--color-blue-dark);\n    border: none;\n    font-size: 20px;\n    color: var(--color-white-main);\n  }\n\n  .header-mb .navbar-item .search-box .search-button:hover {\n    background-color: var(---color-blue-circle);\n    cursor: pointer;\n  }\n\n  .header-mb .navbar-item .navbar-title {\n    width: 100%;\n    text-align: center;\n  }\n\n  .header-mb .navbar-item .navbar-title p {\n    color: var(--color-text-gray);\n    font-family: \"Lexend Deca\", sans-serif;\n    font-size: 17.3px;\n  }\n\n  .header-mb .navbar-item .navbar-title p span {\n    color: var(--color-text-blue);\n  }\n  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {\n    width: 130px;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  header {\n    width: 100%;\n    height: auto;\n  }\n  \n  .navbar .navbar-main {\n    width: 90%;\n    height: 100px;\n  }\n\n  .navbar .navbar-main .logo-header {\n    width: 20%;\n    height: 100px;\n    display: flex;\n    align-items: center;\n  }\n\n  .navbar .navbar-main .logo-header img {\n    width: 100px;\n    height: auto;\n    display: block;\n  }\n\n  .navbar .navbar-main .navbar-items {\n    width: 80%;\n    height: 100px;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item {\n    width: 100%;\n    height: inherit;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .search-box {\n    width: 60%;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    text-align: center;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {\n    width: 75%;\n    height: 50px;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-button {\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    border: none;\n    font-size: 20px;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .cart-info {\n    width: 40%;\n    height: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .cart-info .cart-input {\n    width: auto;\n    height: auto;\n  }\n\n  .navbar\n    .navbar-main\n    .navbar-items\n    .navbar-item\n    .cart-info\n    .cart-input\n    .cart-button {\n    border-radius: 50px;\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    border: none;\n    font-size: 20px;\n    display: block;\n    text-align: center;\n    line-height: 50px;\n    position: relative;\n  }\n\n  .navbar\n    .navbar-main\n    .navbar-items\n    .navbar-item\n    .cart-info\n    .cart-input\n    .cart-button\n    .count-cart {\n    position: absolute;\n    font-size: 11px;\n    top: -12px;\n    right: -3px;\n    line-height: 24px;\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    font-weight: bolder;\n    font-family: \"Poppins\", sans-serif;\n  }\n\n  .navbar\n    .navbar-main\n    .navbar-items\n    .navbar-item\n    .cart-info\n    .cart-text\n    .cart-title {\n    font-family: \"Lexend Deca\", sans-serif;\n    font-size: 16px;\n    font-weight: 300;\n  }\n\n  .navbar\n    .navbar-main\n    .navbar-items\n    .navbar-item\n    .cart-info\n    .cart-text\n    .cart-price {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .navbar-title {\n    width: 70%;\n    text-align: center;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo {\n    width: 30%;\n    height: inherit;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item .navbar-logo img {\n    width: 130px;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item p {\n    color: var(--color-text-gray);\n    font-family: \"Lexend Deca\", sans-serif;\n    font-size: 18px;\n  }\n\n  .navbar .navbar-main .navbar-items .navbar-item p span {\n    color: var(--color-text-blue);\n  }\n\n  .header-mb {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 1025px) {\n  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {\n    width: 86%;\n    height: 50px;\n  }\n}\n\n@media only screen and (min-width: 1600px) { \n  .navbar .navbar-main .navbar-items .navbar-item .search-box .search-input {\n    width: 87.5%;\n    height: 50px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
